import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { logout } from "./store/authSlice";

/**
 * Every tab of a browser shares one login (localStorage). When another tab signs out, or signs in a different account, this tab must not keep
 * showing the old account's screens with the new account's data: it signs out here too, or reloads as the new account.
 */
export function TabSessionGuard() {
  const dispatch = useAppDispatch();
  const userId = useAppSelector((s) => s.auth.user?.id);

  useEffect(() => {
    function onStorage(e: StorageEvent) {
      if (e.key !== "user") return;
      if (!e.newValue) { if (userId !== undefined) dispatch(logout()); return; }
      try {
        const next = JSON.parse(e.newValue);
        if (userId !== undefined && next && next.id !== userId) window.location.reload();
      } catch { /* an unreadable value changes nothing */ }
    }
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [dispatch, userId]);

  return null;
}
